import { faCalendar, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import Button from '../../../App/Components/Button/Button'
import Modal from '../../../App/Components/Modal/Modal'
import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import { IAbsenceRequest } from '../../../HR/AbsenceRequestNew/IAbsenceRequestNew'
import { deleteAbsenceRequest } from '../../../HR/AbsenceRequests/Store/Actions'

import {
  BottomHalf,
  CardContainer,
  CardTitle,
  DateInfo,
  DateText,
  ModalButtonContainer,
  ModalContainer,
  PersonInfo,
  PersonName,
  ProfileAvatar,
  RequestStatus,
  TitleContainer,
  TopHalf,
  TrashIcon,
} from './style'

interface IProps {
  absenceRequest: IAbsenceRequest
  actionType: 'edit' | 'review'
  showTrash?: boolean
}

export const AbsenceRequestCard = ({
  absenceRequest,
  actionType,
  showTrash,
}: IProps) => {
  const [requestCardModal, setRequestCardModal] = useState<boolean>(false)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const history = useHistory()

  const deleteModal = (e: MouseEvent) => {
    e.stopPropagation()
    setRequestCardModal(true)
  }

  const deleteRequest = () => {
    dispatch(deleteAbsenceRequest(absenceRequest)).then(() =>
      history.push(`/profile`),
    )
    setRequestCardModal(false)
  }

  return (
    <>
      <CardContainer
        cardWidth={'100%'}
        style={{ margin: '1em' }}
        hoverSensitive
        onClick={() => {
          actionType === 'edit'
            ? history.push(`/profile/absence-request/edit/${absenceRequest.id}`)
            : history.push(`/hr/absence-requests/${absenceRequest.id}/review`)
        }}>
        <TopHalf container flexDirection={'column'}>
          <TitleContainer container>
            <CardTitle>
              {t(`absence.${absenceRequest.absenceType.key}`)}
            </CardTitle>
            {showTrash && absenceRequest.status === 'PENDING' ? (
              <TrashIcon icon={faTrash} onClick={(e: any) => deleteModal(e)} />
            ) : null}
          </TitleContainer>
          <DateInfo container flexWrap={'nowrap'}>
            <FontAwesomeIcon icon={faCalendar} color={'#005cdb'} />
            <DateText>
              {`${moment(absenceRequest.startsAt).format(
                'dd, MMMM Do YY, H:mm',
              )} - ${moment(absenceRequest.endsAt).format(
                'dd, MMMM Do YY, H:mm',
              )}`}
            </DateText>
          </DateInfo>
        </TopHalf>

        <BottomHalf
          container
          justifyContent={'space-between'}
          flexWrap={'nowrap'}>
          <PersonInfo container>
            <ProfileAvatar
              src={`${absenceRequest.person.avatar}&w=144&h=144&fit=crop`}
              alt={'User avatar image'}
            />
            <PersonName>{`${absenceRequest.person.fullName || ''}`}</PersonName>
          </PersonInfo>
          <RequestStatus status={absenceRequest.status}>
            {t(absenceRequest.status)}
          </RequestStatus>
        </BottomHalf>
      </CardContainer>
      <Modal
        modalState={requestCardModal}
        setModalState={() => setRequestCardModal(false)}>
        <ModalContainer container flexDirection={'column'}>
          <p>{t('You are about to delete this request.')}</p>
          <DateText>
            {`${moment(absenceRequest.startsAt).format(
              'dddd, MMMM Do YYYY, H:mm:ss',
            )} - ${moment(absenceRequest.endsAt).format(
              'dddd, MMMM Do YYYY, H:mm:ss',
            )}`}
          </DateText>
          <ModalButtonContainer container flexDirection={'row'}>
            <Button onClick={() => deleteRequest()}>Delete</Button>
            <Button onClick={() => setRequestCardModal(false)}>Cancel</Button>
          </ModalButtonContainer>
        </ModalContainer>
      </Modal>
    </>
  )
}
